import { render } from "./VacancyManagement.vue?vue&type=template&id=8bc05e42&scoped=true"
import script from "./VacancyManagement.vue?vue&type=script&lang=js"
export * from "./VacancyManagement.vue?vue&type=script&lang=js"

import "./VacancyManagement.vue?vue&type=style&index=0&id=8bc05e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc05e42"]])

export default __exports__